import { createContext, useContext } from 'react';
const context = createContext({});

const useDevice = () => {
  return useContext(context);
};

export default context.Provider;
